import { BlockWrapper, defineBlock, smartProps, useEditor, useInspectorControl } from '@smartfire/js-block-engine';
import Inspector from './Inspector';
import style from './block.module.scss';
import clsx from 'clsx';

const Button = ({
    text,
    link,
    aspect,
    backgroundContained,
    borderContained,
    colorContained,
    styleGhost,
    onClick = undefined,
    Wrapper = 'a',
    inspector = true,
}) => {
    useInspectorControl(() => (inspector ? <Inspector active={inspector} /> : <></>));
    const { isEditing } = useEditor();

    const blockClasses = clsx({
        [style.block]: true,
        [style.contained]: aspect === 'contained',
        [style.ghost]: aspect === 'ghost',
        [style.ghost_style_1]: styleGhost === 'style-1',
        [style.ghost_style_2]: styleGhost === 'style-2',
    });

    return (
        <BlockWrapper.Div className={blockClasses}>
            <Wrapper
                href={!isEditing ? link : undefined}
                onClick={onClick}
                className={style.button}
                style={{
                    border: aspect === 'contained' ? '4px solid' + borderContained : 'none',
                    color: aspect === 'contained' ? colorContained : null,
                    backgroundColor: aspect === 'contained' ? backgroundContained : 'transparent',
                }}
            >
                {aspect === 'ghost' && (
                    <div className={style.arrow}>
                        <span></span>
                    </div>
                )}
                {text}
            </Wrapper>
        </BlockWrapper.Div>
    );
};

export default defineBlock({
    Block: Button,
    smartProps: {
        text: smartProps.string.withDefault('Text du bouton'),
        linkType: smartProps.string.withDefault('internal'),
        link: smartProps.string.withDefault(''),
        blank: smartProps.bool.withDefault(false),
        aspect: smartProps.string.withDefault('contained'),
        backgroundContained: smartProps.string.withDefault(''),
        colorContained: smartProps.string.withDefault(''),
        borderContained: smartProps.string.withDefault(''),
        styleGhost: smartProps.string.withDefault('style-1'),
    },
    setup: {
        title: 'Bouton',
    },
});
